

const semanticTokens = {
    colors: {},
};

export default semanticTokens;